module.exports = __webpack_public_path__ + "media/images/country_flags/la-8779a0e1e413aa8c039bf27ccbcc6284.png";